var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlusIcon = function SvgPlusIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.3,
    d: "M9.854 5.917h-2.77V3.146A.146.146 0 0 0 6.937 3h-.875a.146.146 0 0 0-.146.146v2.77H3.146A.146.146 0 0 0 3 6.063v.875c0 .08.066.146.146.146h2.77v2.771c0 .08.066.146.146.146h.875c.08 0 .146-.066.146-.146v-2.77h2.771c.08 0 .146-.066.146-.146v-.875a.146.146 0 0 0-.146-.146"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.3,
    d: "M6.5 0a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13m0 11.897a5.398 5.398 0 0 1 0-10.794 5.398 5.398 0 0 1 0 10.794"
  })));
};
export default SvgPlusIcon;